import { ContainerModule } from 'inversify';
import { PlayerModuleSymbol } from '../api';
import * as Store from './store';
import * as Service from './service';
import { QuestionAttemptPlayerModule } from './question-attempt-player-module';

const questionAttemptModule = new ContainerModule((bind) => {
  bind(PlayerModuleSymbol).to(QuestionAttemptPlayerModule)
});

export const questionAttemptModules = [
  questionAttemptModule,
  Store.questionAttemptStateModule,
  Service.questionAttemptServiceModule
]
